export var MembershipEnrollmentType;
(function (MembershipEnrollmentType) {
    MembershipEnrollmentType["PACKAGE"] = "package";
    MembershipEnrollmentType["SUBSCRIPTION"] = "subscription";
})(MembershipEnrollmentType || (MembershipEnrollmentType = {}));
export var MembershipBillingFrequency;
(function (MembershipBillingFrequency) {
    MembershipBillingFrequency["DAILY"] = "daily";
    MembershipBillingFrequency["WEEKLY"] = "weekly";
    MembershipBillingFrequency["BIWEEKLY"] = "biweekly";
    MembershipBillingFrequency["MONTHLY"] = "monthly";
    MembershipBillingFrequency["BIMONTHLY"] = "bimonthly";
    MembershipBillingFrequency["QUARTERLY"] = "quarterly";
    MembershipBillingFrequency["ANNUALLY"] = "annually";
})(MembershipBillingFrequency || (MembershipBillingFrequency = {}));
export var MembershipRolloverUsage;
(function (MembershipRolloverUsage) {
    MembershipRolloverUsage["INDEFINITELY"] = "rollover_indefinitely";
    MembershipRolloverUsage["LIMITED"] = "rollover_number_of_cycles";
    MembershipRolloverUsage["RESET"] = "reset";
})(MembershipRolloverUsage || (MembershipRolloverUsage = {}));
export var MembershipItemType;
(function (MembershipItemType) {
    MembershipItemType["SERVICE"] = "Primary Service";
    MembershipItemType["PRODUCT"] = "Product";
    MembershipItemType["ADD_ON"] = "Add-On";
})(MembershipItemType || (MembershipItemType = {}));
export var EnrollmentStatuses = {
    canceled: "canceled",
    paused: "paused",
    active: "active",
    pending: "pending",
    pastDue: "past_due",
};
